import { render } from "./AboutS10.vue?vue&type=template&id=81e8cf8a&scoped=true"
import script from "./AboutS10.vue?vue&type=script&lang=js"
export * from "./AboutS10.vue?vue&type=script&lang=js"

import "./AboutS10.vue?vue&type=style&index=0&id=81e8cf8a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81e8cf8a"]])

export default __exports__